var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4256_97531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3L21 21",
    stroke: "#2C3E50",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8279 9.17188C15.5781 9.92185 15.9997 10.9391 15.9999 11.9999",
    stroke: "#2C3E50",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.657 6.34375C18.8068 7.49303 19.5792 8.96536 19.8713 10.5646C20.1634 12.1639 19.9613 13.8142 19.292 15.2957",
    stroke: "#2C3E50",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16822 14.8279C8.41833 14.0778 7.99707 13.0605 7.99707 11.9999C7.99707 10.9392 8.41833 9.92199 9.16822 9.17188",
    stroke: "#2C3E50",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33694 17.6578C5.59403 16.9149 5.00472 16.0329 4.60266 15.0623C4.20059 14.0917 3.99365 13.0514 3.99365 12.0008C3.99365 10.9501 4.20059 9.90982 4.60266 8.93919C5.00472 7.96856 5.59403 7.08662 6.33694 6.34375",
    stroke: "#2C3E50",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4256_97531)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4256_97531)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 8,
    height: 8,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15C20.2092 15 22 16.7901 22 18.9984C22.0008 20.0482 21.5886 21.0562 20.8524 21.8048C20.1161 22.5533 19.1149 22.9825 18.0648 22.9995C17.0148 23.0165 16.0001 22.62 15.24 21.8957C14.4799 21.1713 14.0352 20.1772 14.002 19.128L14 18.9984L14.0016 18.8865C14.0608 16.7301 15.828 15 18 15ZM18.004 20.1979L17.9532 20.2007C17.856 20.2123 17.7664 20.2591 17.7014 20.3323C17.6364 20.4055 17.6004 20.4999 17.6004 20.5978C17.6004 20.6957 17.6364 20.7901 17.7014 20.8633C17.7664 20.9365 17.856 20.9833 17.9532 20.9948L18 20.9976L18.0508 20.9948C18.148 20.9833 18.2376 20.9365 18.3026 20.8633C18.3676 20.7901 18.4036 20.6957 18.4036 20.5978C18.4036 20.4999 18.3676 20.4055 18.3026 20.3323C18.2376 20.2591 18.148 20.2123 18.0508 20.2007L18.004 20.1979ZM18 16.9992C17.902 16.9992 17.8075 17.0352 17.7343 17.1003C17.661 17.1653 17.6143 17.255 17.6028 17.3523L17.6 17.3991V18.9984L17.6028 19.0452C17.6144 19.1424 17.6612 19.2319 17.7344 19.2969C17.8076 19.3619 17.9021 19.3978 18 19.3978C18.0979 19.3978 18.1924 19.3619 18.2656 19.2969C18.3388 19.2319 18.3856 19.1424 18.3972 19.0452L18.4 18.9984V17.3991L18.3972 17.3523C18.3857 17.255 18.339 17.1653 18.2657 17.1003C18.1925 17.0352 18.098 16.9992 18 16.9992Z",
    fill: "#FF0000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4256_97531",
    x: 11,
    y: 13,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4256_97531"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4256_97531",
    result: "effect2_dropShadow_4256_97531"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4256_97531",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4256_97531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4256_97531"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 8,
    height: 8,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.575d7bc7.svg";
export { ForwardRef as ReactComponent };